// Copyright The Perses Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { z } from 'zod';

import { AnnotationDisplay, AnnotationSpec } from '../dashboard';
import { PluginSchema, pluginSchema } from './plugin';

export const annotationDisplaySchema: z.ZodSchema<AnnotationDisplay> = z.object({
  name: z.string(),
  description: z.string().optional(),
  hidden: z.boolean().optional(),
  color: z.string().optional(),
});

export function buildAnnotationSpecSchema(customPluginSchema: PluginSchema): z.ZodSchema<AnnotationSpec> {
  return z.object({
    display: annotationDisplaySchema,
    plugin: customPluginSchema,
  });
}

export const annotationSpecSchema = z.object({
  display: annotationDisplaySchema,
  plugin: pluginSchema,
});
